module.exports = __webpack_public_path__ + "img/b_rod.29a5f441.png";